import React from 'react';

const Footer = props => (
    <footer>
        <div className="container">
            <div className="row">
                <div className="col-sm-12 text-center">
                    <p>地址：80661高雄市前鎮區成功二路25號7樓</p>
                    <p>諮詢服務專線：0800-588-889 電話：02-27858898　E-Mail：<a style={{color: '#FFEB3B'}} href="mailto:cs@universalec.com">cs@universalec.com</a></p>
                    <p>海洋委員會海洋保育署版權所有©Copyright</p>
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;